<template>
    <div class="permissionAssignment"
      v-loading="showLoad"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <iframe class="register-iframe" :src="permissionAssignmentUrl" frameborder="0" @load="iframeLoad"
        ></iframe>
    </div>
</template>


<script>
import Url from "../../../service/base-url.js";
import { mapState } from "vuex";
export default {
  name: "permissionAssignment",
  data() {
    return {
      showLoad: true
    };
  },
  methods: {
    iframeLoad() {
      this.showLoad = false;
    }
  },
  computed: {
    ...mapState(["loginUser"]),
    permissionAssignmentUrl() {
      return (
        Url.baseUrl +
        "/MenuPermissionConfiguration/role/UnitsUserRoles2?appid=" +
        "1709121849400000101"
      );
    }
  }
};
</script>
<style lang="stylus" scoped>
.permissionAssignment
  height: 100%;
  .register-iframe
    width: 100%;
    height: 100vh;    
</style>
